var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMeridian = function SvgMeridian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0f4366",
    d: "M24 15.84l-3.83-7a5.32 5.32 0 00-1.77-1.71 6.07 6.07 0 00-6.65.25l4.93 8.88h7a.29.29 0 00.32-.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ec0d6",
    d: "M2.93 17.51A6.06 6.06 0 119.2 7.13a5.32 5.32 0 011.73 1.74l3.83 7a.29.29 0 01-.26.43h-1a.14.14 0 01-.12-.08l-3.63-6.7a3.86 3.86 0 00-1.24-1.24 4.72 4.72 0 10-4.89 8.08 2.11 2.11 0 00.25.14.23.23 0 01.16.31c-.06.13-.12.26-.19.39l-.2.42a.3.3 0 01-.17.12.36.36 0 01-.2 0 2.2 2.2 0 01-.34-.23z"
  })));
};
export default SvgMeridian;